import { EventBus, EVENT_BUS } from './eventBus';
import { TextFragmentApi } from './textFragmentApi';

export const MistakeReportModule = (function () {
  let popupOpened = false;
  let popup = null;
  let form = null;
  let cancelButton = null;
  let mistakeTextArea = null;
  let submitButton = null;
  let successMessage = null;
  let fieldsContainer = null;
  let title = null;
  let errorMessage = null;

  let savedSelectionText = '';
  let savedTextFragment = '';
  let savedRange = null;

  const showError = () => {
    if (!errorMessage) {
      errorMessage = popup?.querySelector(
        '.mistake-report-popup__error-message',
      );
    }
    if (errorMessage) {
      errorMessage.style.display = 'block';
      if (successMessage) {
        successMessage.style.display = 'none';
      }
      if (title) {
        title.style.display = 'block';
      }
      if (fieldsContainer) {
        fieldsContainer.style.display = 'block';
      }
      if (submitButton) {
        submitButton.style.display = 'block';
      }
    }
  };

  const hideError = () => {
    if (errorMessage) {
      errorMessage.style.display = 'none';
    }
  };

  const showPopup = () => {
    const selection = window.getSelection();
    const selectedText = selection.toString().trim();

    if (!selectedText) {
      return;
    }

    savedSelectionText = selectedText;
    if (selection.rangeCount > 0) {
      savedRange = selection.getRangeAt(0).cloneRange();
    }

    savedTextFragment = TextFragmentApi.generateUrl(
      savedSelectionText,
      savedRange,
    );

    if (popupOpened) {
      return;
    }
    EventBus.emit(EVENT_BUS.EVENTS.REPORT_MISTAKE);
    if (!popup) {
      popup = document.querySelector('.mistake-report-popup');
      form = popup?.querySelector('.mistake-report-popup__form');
      cancelButton = popup?.querySelector('.button__secondary');
      submitButton = popup?.querySelector('.button__primary');
      mistakeTextArea = popup?.querySelector('#mistake-text');
      successMessage = popup?.querySelector(
        '.mistake-report-popup__success-message',
      );
      fieldsContainer = popup?.querySelector('.mistake-report-popup__fields');
      title = popup?.querySelector('.mistake-report-popup__title');
      errorMessage = popup?.querySelector(
        '.mistake-report-popup__error-message',
      );

      if (mistakeTextArea) {
        mistakeTextArea.setAttribute('readonly', true);
        mistakeTextArea.classList.add(
          'mistake-report-popup__textarea--readonly',
        );
      }
    }

    if (popup && mistakeTextArea) {
      mistakeTextArea.value = selectedText;
      popup.classList.add('opened');
      popupOpened = true;
      hideError();
      if (successMessage) {
        successMessage.style.display = 'none';
      }
      if (title) {
        title.style.display = 'block';
      }
      if (fieldsContainer) {
        fieldsContainer.style.display = 'block';
      }
      if (submitButton) {
        submitButton.style.display = 'block';
      }
    }
  };

  const hidePopup = () => {
    EventBus.emit(EVENT_BUS.EVENTS.REPORT_MISTAKE);
    if (popup) {
      if (cancelButton) {
        cancelButton.classList.remove('button__primary');
        cancelButton.classList.add('button__secondary');
      }
      popup.classList.remove('opened');
      popupOpened = false;
      if (form) {
        form.reset();
      }
      hideError();
      if (successMessage) {
        successMessage.style.display = 'none';
      }
      if (title) {
        title.style.display = 'block';
      }
      if (fieldsContainer) {
        fieldsContainer.style.display = 'block';
      }
      if (submitButton) {
        submitButton.style.display = 'block';
      }
    }
  };

  const showSuccessMessage = () => {
    if (successMessage) {
      successMessage.style.display = 'block';
    }
    if (fieldsContainer) {
      fieldsContainer.style.display = 'none';
    }
    if (submitButton) {
      submitButton.style.display = 'none';
    }
    if (cancelButton) {
      cancelButton.classList.remove('button__secondary');
      cancelButton.classList.add('button__primary');
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!form) return;

    const formData = new FormData(form);
    const selectedText = formData.get('text');

    const textFragmentUrl = savedTextFragment || window.location.href;

    const data = {
      mistakeText: selectedText,
      comment: formData.get('comment') || '',
      url: textFragmentUrl,
    };

    try {
      submitButton.disabled = true;
      hideError();
      const response = await fetch('/v1/api/report-mistake', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
      });

      if (response.ok) {
        showSuccessMessage();
      } else {
        await response.json();
        showError();
      }
    } catch (error) {
      showError();
      console.error('Error:', error);
    } finally {
      submitButton.disabled = false;
    }
  };

  const handleKeyPress = (event) => {
    if (event.ctrlKey && event.key === 'Enter') {
      event.preventDefault();
      showPopup();
    }

    if (event.key === 'Escape' && popup?.classList.contains('opened')) {
      event.preventDefault();
      hidePopup();
    }
  };

  const handleCancelClick = (event) => {
    event.preventDefault();
    hidePopup();
  };

  const init = () => {
    const articleContent = document.querySelector('.article-content');
    if (!articleContent) {
      return;
    }

    document.addEventListener('keydown', handleKeyPress);

    popup = document.querySelector('.mistake-report-popup');
    form = popup?.querySelector('.mistake-report-popup__form');
    cancelButton = popup?.querySelector('.button__secondary');
    submitButton = popup?.querySelector('.button__primary');
    mistakeTextArea = popup?.querySelector('#mistake-text');
    successMessage = popup?.querySelector(
      '.mistake-report-popup__success-message',
    );
    fieldsContainer = popup?.querySelector('.mistake-report-popup__fields');
    title = popup?.querySelector('.mistake-report-popup__title');
    errorMessage = popup?.querySelector('.mistake-report-popup__error-message');

    if (mistakeTextArea) {
      mistakeTextArea.setAttribute('readonly', true);
      mistakeTextArea.classList.add('mistake-report-popup__textarea--readonly');
    }

    if (cancelButton) {
      cancelButton.addEventListener('click', handleCancelClick);
    }

    if (form) {
      form.addEventListener('submit', handleSubmit);
    }

    if (successMessage) {
      successMessage.style.display = 'none';
    }

    TextFragmentApi.addHighlightStyles();
  };

  return { init };
})();
